import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { acessoLocalLiberacoesFinanceiro } from '../services/dashboard/financeiro/dashboard-liberacoes-financeiro.service';

@Injectable({ providedIn: 'root' })
export class LiberacoesFinanceiroGuard implements CanActivate {
  constructor(private router: Router, private toastr: ToastrService) {}
  canActivate(): boolean | UrlTree {
    if (acessoLocalLiberacoesFinanceiro()) return true;
    this.toastr.warning('Relatório exclusivo do financeiro ou diretoria da Sakamoto.');
    return this.router.createUrlTree(['/pedidos']);
  }
}
